export default "__VITE_ASSET__DOrnpcne__"